import React from 'react'
import { Icon } from '@chakra-ui/react'

const Shower = ({ ...props }) => {
  return (
    <Icon
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16.611 10.3636C16.8108 10.3651 17.0012 10.4493 17.1375 10.5964C17.2742 10.7406 17.3451 10.9356 17.3332 11.1345C17.1162 14.7863 14.1122 17.636 10.4793 17.6364H6.85377C3.2209 17.636 0.216902 14.7863 -0.000122311 11.1345C-0.00963739 10.936 0.0606522 10.7421 0.194878 10.5964C0.330208 10.4475 0.521647 10.363 0.7221 10.3636H3.3351C3.49434 10.3652 3.63576 10.2614 3.68321 10.1084C3.87182 9.50441 4.42672 9.09268 5.05543 9.09019H8.67016C9.29887 9.09268 9.85377 9.50441 10.0424 10.1084C10.0894 10.2602 10.229 10.3636 10.3869 10.3636H14.263C14.4625 10.3636 14.6242 10.2008 14.6242 10V2.36364C14.625 2.07623 14.4576 1.8153 14.1971 1.69782C13.9366 1.58035 13.6319 1.62838 13.4195 1.82037L13.1234 2.11855C13.027 2.21627 12.9938 2.36042 13.0374 2.49091C13.2893 3.23992 13.0982 4.06794 12.5442 4.62837L12.3997 4.77746C12.1177 5.06137 11.6605 5.06137 11.3785 4.77746L9.46821 2.8531C9.18627 2.5691 9.18627 2.10873 9.46821 1.82473L9.61627 1.67564C10.1794 1.1339 10.9925 0.947305 11.7331 1.18982C11.8617 1.23098 12.0024 1.19647 12.0978 1.10037L12.4322 0.763641C13.0641 0.175657 13.9816 0.0198747 14.77 0.366706C15.5584 0.713537 16.0684 1.49726 16.0693 2.36364V10C16.0693 10.2008 16.231 10.3636 16.4304 10.3636H16.611ZM8.30544 14.9091C8.50488 14.9091 8.66655 14.7463 8.66655 14.5455V10.9091C8.66655 10.7083 8.50488 10.5455 8.30544 10.5455H5.41655C5.21711 10.5455 5.05544 10.7083 5.05544 10.9091V14.5455C5.05544 14.7463 5.21711 14.9091 5.41655 14.9091H8.30544Z"
        fill="#83B53C"
      />
      <path
        d="M6.4999 4.60948C6.60418 4.6104 6.70742 4.58856 6.80251 4.54548L8.11407 3.93603C8.34874 3.82755 8.50812 3.60124 8.53216 3.34234C8.55621 3.08345 8.44127 2.8313 8.23064 2.68089C8.02001 2.53047 7.74569 2.50464 7.51101 2.61312L6.19729 3.22185C5.88931 3.36495 5.72172 3.70459 5.79447 4.0382C5.86722 4.37181 6.16071 4.60949 6.4999 4.60948Z"
        fill="#83B53C"
      />
      <path
        d="M10.199 8.55198C10.5658 8.70953 10.99 8.53797 11.1466 8.16871L11.7143 6.83053C11.8607 6.46347 11.6889 6.04589 11.3276 5.89059C10.9663 5.7353 10.5481 5.89925 10.3861 6.25962L9.82204 7.59998C9.66659 7.96772 9.83495 8.39287 10.199 8.55198Z"
        fill="#83B53C"
      />
      <path
        d="M7.57309 6.78253C7.85372 7.06786 8.31089 7.07013 8.59431 6.78762L9.62131 5.76508C9.89706 5.48134 9.89591 5.02735 9.61872 4.74505C9.34152 4.46274 8.89073 4.45644 8.60586 4.73089L7.57886 5.75417C7.29532 6.03656 7.29273 6.49693 7.57309 6.78253Z"
        fill="#83B53C"
      />
    </Icon>
  )
}

export default Shower
